import { Box, Progress, Text } from '@chakra-ui/react';

const CapsuleProgress = ({ value }) => {
  return (
    <Box
      position='relative'
      w='100%'
      maxW='96px'
      borderRadius='full'
      overflow='hidden'
      border='1px solid rgba(247, 1, 18, 0.60)'
    >
      <Progress
        height={'28px'}
        value={value}
        size='lg'
        bg='rgba(247, 1, 18, 0.05)'
        colorScheme='red'
        borderRadius='full'
        className='progress-bar'
        sx={{
          '& > div': {
            borderRadius: 'full',
          },
        }}
      />
      <Text
        position='absolute'
        top='50%'
        left='50%'
        transform='translate(-50%, -50%)'
        color='#020202'
        fontSize={16}
      >
        {value}%
      </Text>
    </Box>
  );
};

export default CapsuleProgress;
